import { useEffect, useState } from 'react';
import { api, ApiError, type Camera } from '../api.js';
import { CameraCard } from './CameraCard.js';
import { t } from '../i18n.js';

type Status = 'loading' | 'not-connected' | 'error' | 'ready';

export function VideoSection() {
  const [status, setStatus] = useState<Status>('loading');
  const [cameras, setCameras] = useState<Camera[]>([]);

  const load = async () => {
    try {
      const ns = await api.netatmoStatus();
      if (!ns.configured || !ns.connected) {
        setStatus('not-connected');
        return;
      }
      const r = await api.listCameras();
      setCameras(r.cameras);
      setStatus('ready');
    } catch (e) {
      if (e instanceof ApiError && e.status === 409) {
        setStatus('not-connected');
        return;
      }
      setStatus('error');
    }
  };

  useEffect(() => { void load(); }, []);

  if (status === 'loading') {
    return <div className="section-page"><div className="center-state">{t('video.loading')}</div></div>;
  }
  if (status === 'error') {
    return <div className="section-page"><div className="center-state">{t('video.error')}</div></div>;
  }
  if (status === 'not-connected') {
    return (
      <div className="section-page">
        <div className="coming-soon">
          <div className="coming-soon-icon" aria-hidden="true">📹</div>
          <h2>{t('video.not_connected_title')}</h2>
          <p>{t('video.not_connected_body')}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="section-page">
      <div className="camera-grid">
        {cameras.map((cam) => (
          <CameraCard key={cam.id} camera={cam} onChanged={() => void load()} />
        ))}
      </div>
    </div>
  );
}
